if (!customElements.get('inquiry-drawer')) {
  customElements.define(
    'inquiry-drawer',
    class InquiryDrawer extends DrawerComponent {
      constructor() {
        super();
        
        this._classes = {
          loaded: 'inquiry-drawer-loaded',
        };
      }
      
      get selector() {
        return '.inquiry-drawer__content';
      }
      
      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }
      
      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('inquiry-drawer:open', {
            detail: { id: this.dataset.productId },
          })
        );
      }
      
      handleAfterHide() {
        super.handleAfterHide();
        this.classList.remove(this._classes.loaded);
      }
      
      
      quickview() {
        if (document.querySelector(`.inquiry-drawer-${this.dataset.modalId}`)) {
          setTimeout(() => {
            this.classList.add(this._classes.loaded);
          }, 300);
          
          document.dispatchEvent(
            new CustomEvent('inquiry-drawer:loaded', {
              detail: { id: this.dataset.productId },
            })
          );
        }
      }
      
      disconnectedCallback() {
        super.disconnectedCallback();
        this.handleAfterHide();
      }
    }
  );
}
